import { List, Map } from "immutable";

import { TAG_TYPES } from "@seneca/tags-service-consts";

import tagsActionTypes, { ActionTypes } from "../../../action-types";
import Tag from "../../../models/Tag";

type TagsState = Map<string, Tag>;

function tagFromPayload(payload: any) {
  return new Tag({
    ...payload,
    categoryIds: List(payload.categoryIds),
    details: Map(payload.details)
  });
}

export function makeReducer(actionTypes: ActionTypes) {
  function tagsReducer(state: TagsState = Map<string, Tag>(), action: any) {
    switch (action.type) {
      case actionTypes.RECEIVE_TAGS_AND_CATEGORIES: {
        const tags = action.payload.tags.filter(
          (tag: any) => tag.type === TAG_TYPES.tag
        );
        const newState = Map();
        return newState.withMutations(newState => {
          return tags.reduce((acc: any, tag: any) => {
            return acc.set(tag.id, tagFromPayload(tag));
          }, newState);
        });
      }

      case actionTypes.UPDATE_TAG:
        return state.set(action.payload.id, tagFromPayload(action.payload));

      case actionTypes.DELETE_TAG:
        return state.delete(action.payload);

      default:
        return state;
    }
  }

  return tagsReducer;
}

export default makeReducer(tagsActionTypes);
